import clsx from 'clsx';
import React from 'react';
import styles from './LineTable.module.css';

export const LineTable = ({ className, ...props }: React.HTMLAttributes<HTMLTableElement>) => {
  return <table {...props} className={clsx(styles.table, className)}></table>;
};
